module.exports = __webpack_public_path__ + "img/gongzhonghao.5ad540cd.jpg";